import { render, staticRenderFns } from "./ArchiveCatalogSelect.vue?vue&type=template&id=6dd71580&"
import script from "./ArchiveCatalogSelect.vue?vue&type=script&lang=js&"
export * from "./ArchiveCatalogSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports